import React, {useEffect} from "react";
import {SelectedView} from "../types/types";
import './componentsCSS/TobBarTabs.css';
import {useLocation, useNavigate} from "react-router-dom";
import {FILL_CLIENT_FORM_PATH} from "../consts/consts";

interface SourcesViewProps {
    view: SelectedView,
    setView: (value: (((prevState: SelectedView) => SelectedView) | SelectedView)) => void
}

const TobBarTabs: React.FC<SourcesViewProps> = ({view, setView}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleTabClick = (tab: SelectedView) => {
        setView(tab);
        navigate(`/${tab}`);
    }

    useEffect(() => {
        const currentPath = location.pathname.split("/")[1];

        if (Object.values(SelectedView).includes(currentPath as SelectedView)) {
            setView(currentPath as SelectedView);
        }

    }, [location.pathname, navigate, setView]);

    return (
        <div className="tabs">
            <div className="tab-container">
                {Object.values(SelectedView).map((tab) => (
                    <button
                        key={tab}
                        className={`tab ${view === tab ? "active" : ""}`}
                        onClick={handleTabClick.bind(null, tab)}
                    >
                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                    </button>
                ))}
            </div>

            <div className="tab-container-right">
                <button
                    className="upload-client-form-tab"
                    onClick={() => navigate(FILL_CLIENT_FORM_PATH)}
                >
                    Fill Client Form
                </button>
                <div className="logo-container">
                    <img
                        src={require('../static/psifas_english_logo.svg').default}
                        alt="Psifas Logo"
                        className="logo"
                    />
                </div>
            </div>
        </div>
    );
};

export default TobBarTabs;